import { api } from "./api";
import { Company, CompanyStats } from "../types/company";

export class CompanyService {
  /**
   * Lista todas as empresas com filtros
   */
  static async getAll(params?: {
    ativo?: boolean;
    necessita_preenchimento?: boolean;
    tipo?: string;
    fonte?: string;
    search?: string;
    limit?: number;
    offset?: number;
  }) {
    const response = await api.get(`/companies`, { params });
    return response.data;
  }

  /**
   * Lista empresas que precisam de preenchimento
   */
  static async getPending(limit = 50) {
    const response = await api.get(`/companies/pending`, {
      params: { limit },
    });
    return response.data;
  }

  /**
   * Busca empresa por NIF
   */
  static async getByNif(nif: string) {
    const response = await api.get(`/companies/${nif}`);
    return response.data;
  }

  /**
   * Cria nova empresa
   */
  static async create(data: Partial<Company>) {
    const response = await api.post(`/companies`, data);
    return response.data;
  }

  /**
   * Atualiza empresa existente
   */
  static async update(nif: string, data: Partial<Company>) {
    const response = await api.put(`/companies/${nif}`, data);
    return response.data;
  }

  /**
   * Deleta empresa (soft delete)
   */
  static async delete(nif: string) {
    const response = await api.delete(`/companies/${nif}`);
    return response.data;
  }

  /**
   * Verifica se empresa tem referências em faturas
   */
  static async checkReferences(nif: string) {
    const response = await api.get(`/companies/${nif}/references`);
    return response.data;
  }

  /**
   * Deleta empresa permanentemente (só se não tiver referências)
   */
  static async deletePermanent(nif: string) {
    const response = await api.delete(
      `/companies/${nif}/permanent`
    );
    return response.data;
  }

  /**
   * Força lookup automático de uma empresa
   */
  static async lookup(nif: string) {
    const response = await api.post(`/companies/${nif}/lookup`);
    return response.data;
  }

  /**
   * Lookup em lote de múltiplas empresas
   */
  static async batchLookup(nifs: string[]) {
    const response = await api.post(`/companies/batch-lookup`, {
      nifs,
    });
    return response.data;
  }

  /**
   * Obtém estatísticas das empresas
   */
  static async getStats(): Promise<{
    success: boolean;
    data: {
      companies: CompanyStats;
      lookup: any;
      queue: any;
    };
  }> {
    const response = await api.get(`/companies/stats`);
    return response.data;
  }

  /**
   * Força processamento da fila
   */
  static async processQueue() {
    const response = await api.post(`/companies/queue/process`);
    return response.data;
  }
}
